export default __webpack_public_path__ + "ui/assets/img/arrow-list-left-20.svg";